<template>
  <div class="login-box">
    <div class="home-login">
      <div
        class="home-login-left"
        :style="lefMenuThemeStyle">
        <img
          v-if="!isStarRiver"
          class="logo-bg"
          :src="getLogoBgByTheme()"
          alt="" />
        <img
          v-if="isLogoVisible && isLightTheme()"
          src="@/assets/logo/logo_light.png"
          class="home-login-left-right"
          alt="" />
        <video
          v-if="isStarRiver"
          class="logo-bg"
          autoplay
          muted
          playsinline
          @loadeddata="onVideoLoaded">
          <source
            src="@/assets/logo/login_bg.mp4"
            type="video/mp4" />
          您的浏览器不支持视频标签。
        </video>
      </div>
      <div
        class="home-login-right"
        :style="rightMenuThemeStyle">
        <div
          class="login-panel"
          v-if="active === 'login'">
          <!-- <img
            v-if="isLogoVisible"
            src="logo/logo.png"
            alt="" /> -->
          <div>
            <div class="login-title">
              <span class="login-title-wel">欢迎登录</span>
            </div>
            <div class="login-register">
              <span class="login-register-not">没有账号吗？</span>
              <span
                class="login-register-addRegiser"
                @click="switchPanel('register')"
                >注册新账号</span
              >
            </div>
          </div>
          <!-- 账号登录 -->
          <el-form
            :model="loginForm"
            class="form"
            ref="loginForm"
            :rules="rules"
            v-if="loginType === 'password'">
            <el-form-item prop="userNameOrPhone">
              <el-input
                class="input-primary"
                @focus="onFocus('loginForm', 'userNameOrPhone')"
                placeholder="请输入手机号/用户名"
                prefix-icon="el-icon-user"
                v-model="loginForm.userNameOrPhone">
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                class="input-primary"
                @focus="onFocus('loginForm', 'password')"
                placeholder="请输入密码"
                show-password
                prefix-icon="el-icon-lock"
                v-model="loginForm.password">
              </el-input>
            </el-form-item>
            <!-- <el-form-item v-if="failTimes >= 3">
              <div
                ref="sliderControl"
                class="slider-control"
                @mouseover="onMouseOver"
                @mouseleave="onMouseLeave">
                <div
                  ref="indicator"
                  :class="`indicator ${indicatorStatus}`"
                  :style="`width:${this.indicatorWidth}`"></div>
                <div
                  ref="slider"
                  :class="`slider ${sliderStatus}`"
                  @mousedown="onMouseDown"
                  @mousemove="onMouseMove"
                  @mouseup="onMouseUp">
                  <i
                    v-if="
                      sliderStatus.includes('moving') || sliderStatus === ''
                    "
                    class="el-icon-right"></i>
                  <i
                    v-if="sliderStatus.includes('success')"
                    class="el-icon-check"></i>
                  <i
                    v-if="sliderStatus.includes('error')"
                    class="el-icon-close"></i>
                </div>
                <div class="slider-tips">
                  <span>{{ tipsText }}</span>
                </div>
              </div>
            </el-form-item> -->
            <el-form-item class="remember">
              <div
                class="bottom"
                v-if="loginType === 'password'">
                <div>
                  <el-checkbox
                    class="checkbox-primary"
                    v-model="loginForm.rememberMe"
                    >记住密码</el-checkbox
                  >
                </div>
                <div class="right">
                  <div @click="switchPanel('forget')">忘记密码?</div>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="last-form">
              <el-button
                class="primary-btn primary-angb-btn login-btn"
                size="small"
                type="primary"
                @click="login">
                登录
              </el-button>
            </el-form-item>
            <div class="title changeLoginMethod">
              <div
                @click="switchLoginType('message')"
                :class="`name ${loginType === 'message' ? 'active' : ''}`">
                短信登录
              </div>
            </div>
          </el-form>
          <!-- 手机登录 -->
          <el-form
            :model="loginForm"
            class="form"
            ref="loginForm"
            :rules="rules"
            v-if="loginType === 'message'">
            <el-form-item
              prop="phone"
              class="input-phone">
              <el-input
                class="input-primary"
                @focus="onFocus('loginForm', 'phone')"
                @input="value => onInput('loginForm', 'phone', value)"
                maxlength="11"
                placeholder="请输入手机号码"
                v-model="loginForm.phone">
                <icon-svg
                  size="14"
                  slot="prefix"
                  icon-class="ic-shoujihao" />
              </el-input>
            </el-form-item>
            <div class="flex valiPhone">
              <el-form-item prop="validateNo">
                <el-input
                  class="input-primary"
                  @focus="onFocus('loginForm', 'validateNo')"
                  @input="value => onInput('loginForm', 'validateNo', value)"
                  maxlength="6"
                  placeholder="请输入验证码"
                  v-model="loginForm.validateNo">
                  <icon-svg
                    size="14"
                    slot="prefix"
                    icon-class="ic-yanzhengma" />
                </el-input>
                <el-button
                  class="validatenum-btn"
                  :disabled="loginForm.btnDisable"
                  @click="sendValidateNo('loginForm', 'MessageLogin')"
                  >{{ loginForm.btnName }}</el-button
                >
              </el-form-item>
            </div>
            <el-form-item v-if="failTimes >= 3">
              <div
                ref="sliderControl"
                class="slider-control">
                <div
                  ref="indicator"
                  :class="`indicator ${indicatorStatus}`"
                  :style="`width:${this.indicatorWidth}`"></div>
                <div
                  ref="slider"
                  :class="`slider ${sliderStatus}`"
                  @mousedown="onMouseDown"
                  @mousemove="onMouseMove"
                  @mouseup="onMouseUp">
                  <i
                    v-if="
                      sliderStatus.includes('moving') || sliderStatus === ''
                    "
                    class="el-icon-right"></i>
                  <i
                    v-if="sliderStatus.includes('success')"
                    class="el-icon-check"></i>
                  <i
                    v-if="sliderStatus.includes('error')"
                    class="el-icon-close"></i>
                </div>
                <div class="slider-tips">
                  <span>{{ tipsText }}</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="last-form">
              <el-button
                class="submit-btn primary-btn primary-angb-btn login-btn"
                size="small"
                type="primary"
                @click="login">
                登录
              </el-button>
            </el-form-item>
            <div class="changeLoginMethod">
              <div
                @click="switchLoginType('password')"
                :class="`name ${loginType === 'password' ? 'active' : ''}`">
                账号密码登录
              </div>
            </div>
          </el-form>

          <div
            class="img-box"
            v-if="imgVisible">
            <img
              class="back-img"
              :src="verificatePictureInfo.BackgroundImg"
              alt="" />
            <img
              class="slider-img"
              :style="`top:${verificatePictureInfo.PositionY}px;left:${verificatePictureInfo.PositionX}px`"
              :src="verificatePictureInfo.SlideImg"
              alt="" />
          </div>
        </div>
        <!-- 注册 -->
        <div
          v-show="active === 'register' && registerStep === '1'"
          class="register-panel">
          <div class="title login-title-wel">欢迎注册</div>
          <div class="bottom">
            <span class="haveCount">已有账号？</span>
            <span
              class="highlight"
              @click="switchPanel('login')"
              >返回登录</span
            >
          </div>
          <el-form
            :model="registerForm"
            :rules="rules"
            class="form"
            v-if="registerStep === '1' && $theme.get().value === 'dark'"
            ref="registerForm">
            <el-form-item
              prop="phone"
              class="input-phone">
              <el-input
                class="input-primary"
                @focus="onFocus('registerForm', 'phone')"
                @input="value => onInput('registerForm', 'phone', value)"
                maxlength="11"
                placeholder="请输入手机号码"
                v-model="registerForm.phone">
                <icon-svg
                  size="14"
                  slot="prefix"
                  icon-class="ic-shoujihao" />
              </el-input>
            </el-form-item>
            <div class="flex valiPhone">
              <el-form-item prop="validateNo">
                <el-input
                  class="input-primary"
                  @focus="onFocus('registerForm', 'validateNo')"
                  @input="value => onInput('registerForm', 'validateNo', value)"
                  maxlength="6"
                  placeholder="请输入验证码"
                  v-model="registerForm.validateNo">
                  <icon-svg
                    size="14"
                    slot="prefix"
                    icon-class="ic-yanzhengma" />
                </el-input>
                <el-button
                  class="validatenum-btn"
                  :disabled="registerForm.btnDisable"
                  @click="sendValidateNo('registerForm', 'Register')"
                  >{{ registerForm.btnName }}</el-button
                >
              </el-form-item>
            </div>
            <el-form-item class="last-form">
              <el-button
                size="small"
                type="primary"
                class="submit-btn login-btn primary-btn primary-angb-btn"
                @click="next('registerForm')">
                下一步
              </el-button>
            </el-form-item>
          </el-form>

          <template v-else>
            <register-count
              ref="registerLightForm"
              @backToHome="switchPanel('login')" />
          </template>
        </div>
        <!-- 忘记密码 -->
        <div
          class="forget-panel"
          v-if="active === 'forget'">
          <div class="title login-title-wel">忘记密码</div>
          <div class="bottom">
            <span
              class="highlight"
              @click="switchPanel('login')"
              >返回登录</span
            >
          </div>
          <el-form
            :model="forgetForm"
            :rules="rules"
            class="form"
            v-if="forgetStep === '1'"
            ref="forgetForm">
            <el-form-item prop="phone">
              <el-input
                class="input-primary forget-phone"
                @focus="onFocus('forgetForm', 'phone')"
                @input="value => onInput('forgetForm', 'phone', value)"
                maxlength="11"
                placeholder="请输入手机号码"
                v-model="forgetForm.phone">
                <icon-svg
                  size="14"
                  slot="prefix"
                  icon-class="ic-shoujihao" />
              </el-input>
            </el-form-item>
            <div class="flex valiPhone">
              <el-form-item prop="validateNo">
                <el-input
                  class="input-primary"
                  @focus="onFocus('forgetForm', 'validateNo')"
                  @input="value => onInput('forgetForm', 'validateNo', value)"
                  maxlength="6"
                  placeholder="请输入验证码"
                  v-model="forgetForm.validateNo">
                  <icon-svg
                    size="14"
                    slot="prefix"
                    icon-class="ic-yanzhengma" />
                </el-input>
                <el-button
                  class="validatenum-btn submit-btn"
                  :disabled="forgetForm.btnDisable"
                  @click="sendValidateNo('forgetForm', 'ResetPassword')"
                  >{{ forgetForm.btnName }}</el-button
                >
              </el-form-item>
            </div>
            <el-form-item class="last-form">
              <el-button
                size="small"
                type="primary"
                class="submit-btn submit-btn login-btn primary-btn primary-angb-btn"
                @click="next('forgetForm')">
                下一步
              </el-button>
            </el-form-item>
          </el-form>
          <el-form
            :model="forgetForm"
            :rules="rules"
            class="form"
            v-if="forgetStep === '2'"
            ref="forgetForm">
            <el-form-item prop="password">
              <el-input
                class="input-primary"
                @focus="onFocus('forgetForm', 'password')"
                placeholder="请输入密码"
                show-password
                prefix-icon="el-icon-lock"
                v-model="forgetForm.password">
              </el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input
                class="input-primary"
                @focus="onFocus('forgetForm', 'confirmPassword')"
                placeholder="请再次输入密码"
                show-password
                prefix-icon="el-icon-lock"
                v-model="forgetForm.confirmPassword">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                size="small"
                type="primary"
                class="submit-btn primary-btn forget-btn primary-angb-btn"
                @click="resetPassword">
                确认
              </el-button>
              <!-- <div class="submit-btn">确认</div> -->
            </el-form-item>
          </el-form>
        </div>
        <!-- 注册账号 -->
        <RegisterInfoForm
          class="register-count"
          v-if="isRegisterPanel()"
          :register="register"
          :switchPanel="switchPanel" />
        <div
          class="footer"
          v-if="isLogoVisible">
          Copyright © 2017-{{ getCurrYear() }} 上海秉匠信息科技有限公司 版权所有
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import "@wangeditor/editor/dist/css/style.css";
// import { createEditor } from "@wangeditor/editor";
import RegisterInfoForm from './login/components/RegisterInfoForm.vue'
import CryptoJS from 'crypto-js'
import { passwordRules, phoneRules } from '@/utils/formValidateRules'
import { encryptPassword } from '@/utils/generalMethods'
import registerCount from '@/layout/register'

import {
  //   getDocumentList,
  loginService,
  phoneLoginService,
  sendValidateNoService,
  validateMessageNo,
  registerService,
  resetPasswordService,
  getVerificatePicture,
  getVerificateResult
} from '@/service/interface'
import { TokenManager } from '@/utils/tokenManage'

export default {
  data() {
    const validConfirmPassword = (rule, value, callback) => {
      if (this.active === 'forget' && value === this.forgetForm.password) {
        callback()
      } else {
        return callback(new Error('两次输入密码不一致'))
      }
    }
    const validPhoneNo = (rule, value, callback) => {
      let reg = /^[1][2-9][0-9]{9}$/
      if (reg.test(value)) {
        this.loginForm.btnDisable = false
        this.registerForm.btnDisable = false
        this.forgetForm.btnDisable = false
        callback()
      } else {
        this.loginForm.btnDisable = true
        this.registerForm.btnDisable = true
        this.forgetForm.btnDisable = true
        let reg2 = /^[1][2-9][0-9]{1}$/
        if (value.length > 2 && !reg2.test(value.substr(0, 3))) {
          return callback(new Error('请输入合法的手机号码'))
        }
      }
    }
    return {
      isStarRiver: window.isStarRiver,
      isLogoVisible: window.isLogoVisible,
      isPrivate: window.isPrivate,
      // notifyVisible: true,

      active: 'login',
      loginType: 'password',
      loginForm: {
        userNameOrPhone: '',
        phone: '',
        validateNo: '',
        password: '',
        rememberMe: false,
        btnName: '发送验证码',
        btnDisable: true
      },
      registerStep: '1',
      registerForm: {
        phone: '',
        validateNo: '',
        isActive: true,
        btnName: '发送验证码',
        validateType: 'Register',
        btnDisable: true
      },
      forgetStep: '1',
      forgetForm: {
        phone: '',
        validateNo: '',
        password: '',
        confirmPassword: '',
        validateType: 'ResetPassword',
        btnName: '发送验证码',
        btnDisable: true
      },
      visible: false,
      previousRouter: '',
      failTimes: 0,
      imgVisible: false,
      verificatePictureInfo: {},
      indicatorWidth: 0,
      sliderStatus: '',
      indicatorStatus: '',
      tipsText: '向右拖动滑块填充拼图',
      indicatorSuccess: false,
      editorConfig: {
        readOnly: true
      },
      rules: {
        phone: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
          },
          {
            pattern: phoneRules.pattern,
            message: phoneRules.message,
            trigger: 'blur'
          },
          { validator: validPhoneNo }
        ],
        userNameOrPhone: [
          { required: true, message: '请输入手机号/用户名', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9_\u4e00-\u9fa5]{2,20}$|^[1][2-9][0-9]{9}$/,
            message: '手机号码或2-20位字符, 仅可含汉字、字母、数字、下划线',
            trigger: 'blur'
          }
        ],
        validateNo: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            pattern: /^[0-9]{6}$/,
            message: '请输入正确的验证码',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: 'blur'
          },
          { validator: validConfirmPassword, trigger: 'blur' }
        ]
      },
      lefMenuThemeStyle: {},
      rightMenuThemeStyle: {}
    }
  },
  components: {
    RegisterInfoForm,
    registerCount
  },
  async mounted() {
    const themeType = this.$theme.get().value
    if (themeType === 'stellar-light') {
      this.lefMenuThemeStyle = {
        width: '100%'
      }
      this.rightMenuThemeStyle = {
        width: 'unset',
        position: 'unset'
      }
    } else if (themeType === 'dark') {
      this.lefMenuThemeStyle = {
        width: '100%'
      }
      this.rightMenuThemeStyle = {
        width: '0',
        position: 'static'
      }
    }

    let { tokenId, loginMode } = this.$route.query
    if (loginMode) {
      this.switchPanel(loginMode)
      return
    }
    if (tokenId) {
      tokenId = decodeURIComponent(tokenId)
      const tokenId_enc = CryptoJS.AES.decrypt(tokenId, 'developer666')
      tokenId = tokenId_enc.toString(CryptoJS.enc.Utf8)

      sessionStorage.setItem('token', tokenId)
      sessionStorage.setItem('tokenId', tokenId)
      sessionStorage.setItem('recentLogin', new Date().getTime())
      sessionStorage.setItem('loginFlag', true)

      this.$router.push('./projectList')
      return
    }

    this.getCookie()
    let loginFlag = sessionStorage.getItem('loginFlag')
    if (!(loginFlag && loginFlag !== 'false')) return
    if (document.cookie.length > 0 && !loginFlag) {
      this.login()
    }
  },
  methods: {
    onVideoLoaded(event) {
      event.target.playbackRate = 0.5
    },
    handleClose() {
      this.visible = false
    },

    switchLoginType(loginType) {
      this.loginType = loginType
      this.failTimes = 0
      this.$refs.loginForm.clearValidate()
      this.loginForm = {
        userNameOrPhone: '',
        phone: '',
        validateNo: '',
        password: '',
        rememberMe: false,
        btnName: '发送验证码',
        btnDisable: true
      }
    },
    sendValidateNo(formType, validateType) {
      // this.$message.error("服务升级中");

      let validateFailFlag = false
      this.$refs[formType].validateField('phone', error => {
        if (error) {
          this.$message.error(error)
          validateFailFlag = true
        }
      })
      if (validateFailFlag) return
      let params = {
        phone: this[formType].phone,
        validateType: validateType
      }
      let startTime = new Date().getTime()
      this[formType].btnDisable = true
      this[formType].btnName = `60s后重试`
      this.timer = setInterval(() => {
        let currentTime = new Date().getTime()
        let deltaTime = parseInt((currentTime - startTime) / 1000)
        if (deltaTime >= 60) {
          clearInterval(this.timer)
          this[formType].btnDisable = false
          this[formType].btnName = '发送验证码'
        } else {
          this[formType].btnName = `${60 - deltaTime}s后重试`
        }
      }, 1000)
      sendValidateNoService(params).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            this.$message.success('验证码发送成功')
          } else {
            this.$message.error(data.errMsg)

            this[formType].phone = ''
            this[formType].validateNo = ''
            this.active = 'register'
            this.registerStep = '1'
            this.$refs[formType].resetFields()
          }
        }
      })
    },
    login() {
      // this.$message.error("服务升级中");

      let validateFailFlag = false
      let dictionary = {
        password: ['userNameOrPhone', 'password'],
        message: ['phone', 'validateNo']
      }
      this.$refs.loginForm.validateField(dictionary[this.loginType], error => {
        if (error) {
          validateFailFlag = true
          this.$message.error(error)
        }
      })
      if (validateFailFlag) return
      if (this.loginType === 'password') {
        this.loginByPassword()
      } else {
        this.loginByPhone()
      }
    },
    loginByPassword() {
      let params = {
        userNameOrPhone: this.loginForm.userNameOrPhone,
        password: encryptPassword(this.loginForm.password),
        rememberMe: this.loginForm.rememberMe
      }
      loginService(params).then(response => {
        if (response.status === 200) {
          let data = response.data
          if (data.isSuccess) {
            this.$message.success('登录成功')
            sessionStorage.setItem('token', data.token)
            // setHomeToken(data.token)
            TokenManager.setToken(data.token)
            sessionStorage.setItem('tokenId', data.tokenId)
            sessionStorage.setItem('recentLogin', new Date().getTime())
            sessionStorage.setItem('loginFlag', true)

            if (this.loginForm.rememberMe) {
              let userName = this.loginForm.userNameOrPhone
              let password = this.loginForm.password
              this.setCookie(userName, password, 7)
            } else {
              this.clearCookie()
            }
            this.$router.push('./projectList')
          } else {
            let errMsg = data.errMsg
            let message = errMsg.split('#$')
            this.failTimes = Number(message[1])
            this.$message.error(message[0])

            // 如果人机验证不通过，增加滑块验证
            if (data.errMsg.includes('人机验证不通过')) {
              this.failTimes = 3
            }

            if (this.failTimes >= 3) {
              this.indicatorSuccess = false
              this.sliderStatus = ''
              this.indicatorStatus = ''
            }

            // 如果密码不正确，则清空密码
            if (data.errMsg.includes('密码不正确')) {
              this.loginForm.password = ''
            }

            // 如果用户不存在，则清空输入，并打开注册界面
            if (data.errMsg.includes('用户不存在')) {
              this.loginForm.userNameOrPhone = ''
              this.active = 'register'
              this.registerStep = '1'
              this.$refs.loginForm.resetFields()
            }
          }
        }
      })
    },
    loginByPhone() {
      let params = {
        phone: this.loginForm.phone,
        validateNo: this.loginForm.validateNo,
        rememberMe: this.loginForm.rememberMe
      }
      phoneLoginService(params).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            this.$message.success('登录成功')
            sessionStorage.setItem('userId', data.userId)
            sessionStorage.setItem('token', data.token)
            // setHomeToken(data.token)
            TokenManager.setToken(data.token)
            sessionStorage.setItem('tokenId', data.tokenId)
            sessionStorage.setItem('recentLogin', new Date().getTime())
            sessionStorage.setItem('loginFlag', true)
            this.$router.push('./projectList')
          } else {
            let errMsg = data.errMsg
            let message = errMsg.split('#$')
            this.failTimes = Number(message[1])
            this.$message.error(message[0])

            // 如果人机验证不通过，增加滑块验证
            if (data.errMsg.includes('人机验证不通过')) {
              this.failTimes = 3
            }

            if (this.failTimes >= 3) {
              this.indicatorSuccess = false
              this.sliderStatus = ''
              this.indicatorStatus = ''
            }

            // 如果用户不存在，则清空输入，并打开注册界面
            if (data.errMsg.includes('用户不存在')) {
              this.loginForm.phone = ''
              this.active = 'register'
              this.registerStep = '1'
              this.$refs.loginForm.resetFields()
            }
          }
        }
      })
    },
    next(formType) {
      this.$refs[formType].validateField(['phone', 'validateNo'], error => {
        if (error) {
          this.$message.error(error)
          return
        }
      })
      let params = {
        phone: this[formType]['phone'],
        validateType: this[formType]['validateType'],
        validateNo: this[formType]['validateNo']
      }
      validateMessageNo(params).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            if (formType === 'registerForm') {
              this.registerStep = '2'
            }
            if (formType === 'forgetForm') {
              this.forgetStep = '2'
            }
          } else {
            this.$message.error(data.errMsg)
          }
        }
      })
    },
    register(params) {
      params.phone = this.registerForm.phone
      params.validateNo = this.registerForm.validateNo
      params.isActive = this.registerForm.isActive
      registerService(params).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            this.$message.success('注册成功')
            this.active = 'login'
            this.loginType = 'password'
            // this.loginForm.userName = this.registerForm.userName;
            // this.loginForm.password = this.registerForm.password;
          } else {
            this.$message.error(data.errMsg)
          }
          this.registerForm = {
            phone: '',
            validateNo: '',
            isActive: true,
            validateType: 'Register',
            btnName: '发送验证码',
            btnDisable: true
          }
          this.registerStep = '1'
        }
      })
    },
    resetPassword() {
      this.$refs.forgetForm.validate((bool, object) => {
        if (bool) {
          let params = {
            phone: this.forgetForm.phone,
            validateNo: this.forgetForm.validateNo,
            password: encryptPassword(this.forgetForm.password),
            confirmPassword: encryptPassword(this.forgetForm.confirmPassword)
          }
          resetPasswordService(params).then(res => {
            if (res.status === 200) {
              let data = res.data
              if (data.isSuccess) {
                this.$message.success('密码重置成功')
                this.active = 'login'
                this.loginType = 'password'
                this.loginForm.userName = ''
                this.loginForm.password = ''
                this.loginForm.rememberMe = false
                this.clearCookie()
              } else {
                this.$message.error(data.errMsg)
              }
              this.forgetForm = {
                phone: '',
                validateNo: '',
                password: '',
                passwordAgain: '',
                btnName: '发送验证码',
                btnDisable: false
              }
              this.$refs.forgetForm.resetFields()
              this.forgetStep = '1'
            }
          })
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    switchPanel(panelName) {
      // this.$message.error("服务升级中");
      if (panelName === 'login') {
        this.active = 'login'
        this.$refs.registerForm && this.$refs.registerForm.clearValidate()
        this.loginForm = {
          userName: '',
          phone: '',
          validateNo: '',
          password: '',
          rememberMe: false,
          btnName: '发送验证码',
          btnDisable: true
        }
        this.$refs?.registerLightForm?.resetFields()
      }
      if (panelName === 'register') {
        this.active = 'register'
        this.registerStep = '1'
        this.$refs.loginForm && this.$refs.loginForm.clearValidate()
        this.registerForm = {
          phone: '',
          validateNo: '',
          isActive: true,
          validateType: 'Register',
          btnName: '发送验证码',
          btnDisable: true
        }
      }
      if (panelName === 'forget') {
        this.active = 'forget'
        this.forgetStep = '1'
        this.$refs.loginForm && this.$refs.loginForm.clearValidate()
        this.loginForm = {
          userName: '',
          phone: '',
          validateNo: '',
          password: '',
          rememberMe: false,
          btnName: '发送验证码',
          btnDisable: true
        }
      }
    },
    setCookie(name, psw, exdays) {
      let exdate = new Date()
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)

      let userName = CryptoJS.AES.encrypt(name, 'secretkey123').toString()
      let password = CryptoJS.AES.encrypt(psw, 'secretkey123').toString()
      // todo
      localStorage.setItem(
        'userinfo',
        JSON.stringify({
          userName,
          password,
          rem: this.loginForm.rememberMe ? 1 : 0
        })
      )
      window.document.cookie = `userName==${userName};path=/;expires=${exdate.toGMTString()}`
      window.document.cookie = `password==${password};path=/;expires=${exdate.toGMTString()}`
    },
    getCookie() {
      // if (document.cookie.length > 0) {
      //   let arr = document.cookie.split('; ')
      //   for (let i = 0; i < arr.length; i++) {
      //     let arr2 = arr[i].split('==')
      //     if (arr2[0] == 'userName') {
      //       let userName = CryptoJS.AES.decrypt(arr2[1], 'secretkey123')
      //       userName = userName.toString(CryptoJS.enc.Utf8)
      //       this.loginForm.userNameOrPhone = userName
      //     } else if (arr2[0] == 'password') {
      //       let password = CryptoJS.AES.decrypt(arr2[1], 'secretkey123')
      //       password = password.toString(CryptoJS.enc.Utf8)
      //       this.loginForm.password = password
      //     }
      //   }
      // }
      const userInfo = localStorage.getItem('userinfo') || '{}'
      const { rem = 0, userName = '', password = '' } = JSON.parse(userInfo)
      if (rem == 1) {
        this.loginForm.userNameOrPhone = CryptoJS.AES.decrypt(
          userName,
          'secretkey123'
        ).toString(CryptoJS.enc.Utf8)

        this.loginForm.password = CryptoJS.AES.decrypt(
          password,
          'secretkey123'
        ).toString(CryptoJS.enc.Utf8)
        this.loginForm.rememberMe = true
      } else {
        this.$nextTick(() => {
          this.$refs.loginForm && this.$refs.loginForm.resetFields()
          this.loginForm.rememberMe = false
        })
      }
      // if (this.loginForm.userNameOrPhone != '') {
      //   this.loginForm.rememberMe = true
      // } else {
      //   this.loginForm.rememberMe = false
      // }
    },
    clearCookie() {
      this.setCookie('', '', -1)
    },
    onFocus(formType, formProps) {
      this.$refs[formType].clearValidate([formProps])
    },
    onInput(formType, formProps, value) {
      if (isNaN(value)) {
        // this.$message.warning("请输入数字");
        this[formType][formProps] = value.replace(/\D/g, '')
        // this.$refs[formType].clearValidate([formProps]);
      }
    },
    getCurrYear() {
      return new Date().getFullYear()
    },
    // setHtml(html) {
    //   if (this.editor) {
    //     this.editor.destroy();
    //     this.editor = null;
    //   }
    //   this.editor = createEditor({
    //     selector: "#editor",
    //     config: this.editorConfig,
    //     mode: "default",
    //     html,
    //   });
    // },
    onMouseOver() {
      if (this.indicatorSuccess) return
      if (this.failTimes >= 3) {
        this.imgVisible = true
        if (!this.startTime) {
          this.startTime = new Date().getTime()
        }
        let endTime = new Date().getTime()
        let deltaTime = endTime - this.startTime

        let dictionary = {
          password: ['userName', 'password'],
          message: ['phone', 'validateNo']
        }
        if (
          !Object.keys(this.verificatePictureInfo).length ||
          deltaTime > 5 * 60 * 1000
        ) {
          let params = {
            phone: this.loginForm[dictionary[this.loginType][0]]
          }
          getVerificatePicture(params).then(res => {
            if (res.status === 200) {
              let data = res.data.data
              this.verificatePictureInfo = data
            }
          })
        }
      }
    },
    onMouseLeave() {
      // this.imgVisible = false;
    },
    onMouseDown(e) {
      this.mouseDown = true
      this.mouseDownX = e.clientX
      this.indicatorWidth = this.$refs.indicator.clientWidth
    },
    onMouseMove(e) {
      if (!this.mouseDown || this.indicatorSuccess) return false
      let deltaX = e.clientX - this.mouseDownX
      this.verificatePictureInfo.PositionX = deltaX
      let maxWidth = this.$refs.sliderControl.offsetWidth - 40
      if (deltaX < 0 || deltaX > maxWidth) return
      this.$refs.indicator.style.width = `${
        this.indicatorWidth + deltaX + 40
      }px`
      this.$refs.slider.style.left = `${this.indicatorWidth + deltaX}px`

      this.sliderStatus = 'slider-moving'
      this.indicatorStatus = 'indicator-moving'
      this.tipsText = ''
    },
    onMouseUp() {
      this.mouseDown = false
      if (this.indicatorSuccess) return

      let dictionary = {
        password: ['userName', 'password'],
        message: ['phone', 'validateNo']
      }
      let params = {
        phone: this.loginForm[dictionary[this.loginType][0]],
        positionX: this.verificatePictureInfo.PositionX
      }
      getVerificateResult(params).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            this.$message.success('验证成功！！！')
            this.indicatorSuccess = true
            this.imgVisible = false
            this.sliderStatus = 'slider-success'
            this.indicatorStatus = 'indicator-success'
          } else {
            this.indicatorSuccess = false
            this.sliderStatus = 'slider-error'
            this.indicatorStatus = 'indicator-error'
            this.tipsText = '加载中...'
            setTimeout(() => {
              this.sliderStatus = ''
              this.indicatorStatus = ''
              this.$refs.indicator.style.width = '0px'
              this.$refs.slider.style.left = '0px'
              this.tipsText = '向右拖动滑块填充拼图'
            }, 500)
            let params = {
              phone: this.loginForm[dictionary[this.loginType][0]]
            }
            getVerificatePicture(params).then(res => {
              if (res.status === 200) {
                let data = res.data.data
                this.verificatePictureInfo = data
              }
            })
          }
        }
      })
    },
    isRegisterPanel() {
      if (this.active === 'register' && this.registerStep === '2') {
        return true
      } else {
        return false
      }
    },
    isLightTheme() {
      const themeName = this.$theme.get().value
      return themeName === 'stellar-light'
    },
    getLogoBgByTheme() {
      const themeName = this.$theme.get().value
      let thumbnail
      switch (themeName) {
        case 'stellar-light':
          thumbnail = require('@/assets/logo/login_bg_light.png')
          break
        case 'dark':
          thumbnail = require('@/assets/logo/login_bg_dark.webp')
          break
      }
      return thumbnail
    },
    closeNotify() {
      this.notifyVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.login-box {
  position: relative;
  height: 100vh;
  user-select: none;

  .home-login {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    background-color: var(--login-bg-color);
    .input-primary {
      :deep(.el-input__inner) {
        color: var(--login-input-text-color);
        background-color: var(--login-panel-input-bgColor);
        border-color: var(--login-panel-input-border-color);
      }
    }
    &-left {
      height: 100%;
      position: relative;

      .logo-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &-right {
        height: 70px;
        position: absolute;
        top: 57px;
        left: 20px;
        z-index: 999;
      }

      &-left {
        width: 121px;
        height: 36px;
        position: absolute;
        top: 32px;
        left: 32px;
      }
    }

    &-right {
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .forget-panel,
      .register-panel,
      .login-panel {
        // position: absolute;
        // top: 144px;
        // right: 84px;
        width: 456px;
        height: 505px;
        border-radius: 5px;
        background-color: var(--login-panel-bg-color);
        box-shadow: var(--login-panel-box-shadow);
        border-radius: 16px;
        border: 1px solid var(--login-panel-border-color);
        padding: 56px 50px 36px 50px;
        text-align: left;
        position: absolute;
        right: 112px;

        .forget-phone {
          :deep(.el-input__prefix) {
            display: flex;
            align-items: center;
            left: 10px;
          }
        }

        .login-title {
          margin-bottom: 28px;
          text-align: center;
          &-wel {
            color: var(--login-panel-title-color);
            font-size: 36px;
          }

          &-tex {
            margin-left: 16px;
            color: var(--login-panel-sub-title-color);
            font-size: 16px;
          }
        }

        .login-register {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 28px;
          &-not {
            color: var(--login-panel-tip-color);
            font-size: 14px;
            font-weight: 400;
          }

          &-addRegiser {
            // margin-left: 8px;
            color: var(--base-primary-bgColor);
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
          }
        }
        .form {
          :deep(.el-form-item) {
            margin-bottom: 24px;
            .el-input__inner {
              border-radius: 8px;
              // background: var(--aside-bg-color);
              // border: 1px solid var(--base-border-dark-color18);
              &:-webkit-autofill,
              &:-webkit-autofill:hover,
              &:-webkit-autofill:focus,
              &:-webkit-autofill:active {
                -webkit-transition-delay: 99999s;
                -webkit-transition: color 99999s ease-out,
                  background-color 99999s ease-out;
              }
            }

            .el-form-item__content {
              .el-form-item__error {
                font-size: 11px;
              }
            }
          }

          .remember {
            :deep(.el-form-item__content) {
              line-height: normal;
            }
            .bottom {
              width: 100%;
              display: flex;
              justify-content: space-between;

              .checkbox-primary {
                :deep(.el-checkbox__label) {
                  color: var(--login-checkbox-text-color) !important;
                  font-size: 14px;
                  font-weight: 400;
                }
              }

              .right {
                color: var(--base-primary-bgColor);
                font-size: 14px;
                font-weight: 400;
                cursor: pointer;
              }
            }
          }

          .last-form {
            margin-bottom: 28px;
            .login-btn {
              padding-top: 13px;
              padding-bottom: 13px;
              width: 100%;

              :deep(span) {
                display: inline-block;
                font-size: 16px;
                font-weight: 400;
                color: var(--base-light-color25);
              }
            }
          }

          .changeLoginMethod {
            font-size: 14px;
            font-weight: 400;
            color: var(--base-primary-bgColor);
            margin-bottom: 116px;

            .name {
              cursor: pointer;
              display: inline-block;
            }
          }

          .input-phone {
            :deep(.el-form-item__content) {
              line-height: 39px;
            }
            :deep(.el-input) {
              .el-input__prefix {
                display: flex;
                align-items: center;
                left: 10px;
              }
            }
          }

          .valiPhone {
            :deep(.el-form-item__content) {
              display: flex;
              justify-content: flex-start;
              line-height: 39px;

              .el-input__prefix {
                display: flex;
                align-items: center;
                left: 10px;
              }

              .validatenum-btn {
                margin-left: 16px;
                padding-left: 18px;
                padding-right: 18px;
                border-color: var(--validatenum-btn-border-color);
                border-radius: 8px;
                color: var(--validatenum-btn-color);
                background: var(--validatenum-btn-bg-color);

                &.is-disabled {
                  color: var(--validatenum-btn-diabled-color);
                  background-color: var(--validatenum-btn-diabled-bg-color);

                  &:hover {
                    color: var(--validatenum-btn-diabled-color);
                    background-color: var(--validatenum-btn-diabled-bg-color);
                  }
                }
                &:hover {
                  background: var(--validatenum-btn-hover-bg-color);
                  color: var(--validatenum-btn-hover-color);
                }
              }
            }
          }
        }
      }

      .forget-panel,
      .register-panel {
        .bottom {
          margin-top: 26px;
          margin-bottom: 27px;
        }

        .haveCount {
          color: var(--login-panel-tip-color);
          font-size: 14px;
          font-weight: 400;
        }

        .highlight {
          color: var(--base-primary-bgColor);
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
        }
      }

      .register-panel:has(.register) {
        height: 610px;
        padding: 20px 40px 26px 40px;
        width: 560px;
        right: 50px;
      }

      .forget-panel {
        .title {
          margin-bottom: 28px;
        }

        .bottom {
          margin-bottom: 28px;

          .highlight {
            cursor: pointer;
            color: var(--base-primary-bgColor);
            font-size: 14px;
            font-weight: 400;
          }
        }

        .forget-btn {
          padding-top: 13px;
          padding-bottom: 13px;
          width: 100%;

          :deep(span) {
            display: inline-block;
            font-size: 16px;
            font-weight: 400;
            color: var(--base-light-color25);
          }
        }
      }

      .footer {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 64px;
        white-space: nowrap;
        color: var(--copyright-text-color);
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  // .el-button {
  //   padding: 9px 20px;
  //   border: none;
  //   color: #53baf9;
  //   background: transparent;

  //   &:hover {
  //     color: #53baf9;
  //   }
  // }

  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #c0c4cc;
  }

  @media screen and (max-width: 1600px) {
    // .welcome {
    //   top: 220px;
    //   left: 120px;
    //   transform: scale(0.7);
    // }

    // .login-panel {
    //   right: 30px;
    // }

    // .register-panel {
    //   right: 30px;
    // }

    // .forget-panel {
    //   right: 30px;
    // }
  }
}
</style>
